module.exports = "<div class=\"paging-area q-marg-top-xl\"> <div class=row> <div class=\"col-md-2 col-xs-12\"> <select class=\"select2-select page-select\" style=width:100% data-minimum-results-for-search=Infinity> {%= pageSelect %} </select> </div> <div class=\"col-md-3 col-xs-12 q-text-center-at-md q-marg-top-md-at-md q-marg-top-xs-til-md page-info\"> {%- pageInfo %} </div> <div class=\"col-md-7 col-xs-12\"> <div class=\"q-pull-right-til-md q-marg-top-md-at-md nav-btn-wrap\"> {%= pageButtons %} </div> </div> </div> </div> {%= loaderOverlay %}";


//////////////////
// WEBPACK FOOTER
// ./src/components/pagableComponent/html/pagingArea.html
// module id = 1165
// module chunks = 1